<div [ngClass]="{ 'row': true, 'show active': active, 'hide d-none': !active }">
  <slot></slot>
</div>
